import { AppState } from '../../reducers';
import { CategoriesState } from './redtail.category.reducer';

export const categoriesSelector = (state: AppState): CategoriesState => state.redtail.categories;
